import { useMutation, useQueryClient } from "react-query";
import {
  cancelTerminalPaymentSession,
  createInterwitchAccount,
  createTerminalBusinessAccount,
  createTerminalPaymentSession,
  createTerminals,
  deleteInterwitchAccount,
  deleteTerminals,
  retryTerminalPaymentSession,
  testTerminalConnection,
  updateInterwitchAccount,
  updateTerminals,
} from "../../../services/pos-terminals";

export const useCreateTerminals = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createTerminals(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchTerminals"]);
    },
  });
};

export const useUpdateTerminals = (id) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateTerminals({ id: id, data }), {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchTerminals"]);
      queryClient.invalidateQueries(["getTerminalsDetails", `${id}`]);
    },
  });
};

export const useDeleteTerminals = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteTerminals(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchTerminals"]);
    },
  });
};

export const useDeleteInterwitchAccount = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteInterwitchAccount(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getInterwitchAccount"]);
    },
  });
};

export const useCreateTerminalPaymentSession = ({ id = null }) => {
  return useMutation((data) =>
    createTerminalPaymentSession({ id, data }).then((res) => res?.data?.data),
  );
};

export const useRetryTerminalPaymentSession = ({ id = null }) => {
  return useMutation((data) =>
    retryTerminalPaymentSession({ id, data }).then((res) => res?.data?.data),
  );
};

export const useCancelTerminalPaymentSession = ({ id = null }) => {
  return useMutation((data) =>
    cancelTerminalPaymentSession({ id, data }).then((res) => res?.data?.data),
  );
};

export const useCreateInterwitchAccount = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createInterwitchAccount(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getInterwitchAccount"]);
    },
  });
};

export const useUpdateInterwitchAccount = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateInterwitchAccount(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getInterwitchAccount"]);
    },
  });
};

export const useCreateTerminalBusinessAccount = ({ path, queryKey = "" }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => createTerminalBusinessAccount(data, path), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey]);
    },
  });
};

export const useTestTerminalConnection = () => {
  return useMutation((data) => testTerminalConnection(data));
};
